import { useState, useMemo, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import cn from 'classnames';

import styles from './DatePicker.module.css';

const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <div 
    className={cn(styles.datepicker, !value && styles.placeholder, !value && 'datapicker-placeholder')} 
    onClick={onClick} ref={ref}
  >
    {value || placeholder}
  </div>
));

CustomInput.displayName = 'CustomInput';

const DatePickerComponent = (props) => {
  const {
    onChange,
    initialValue,
    placeholder,
    dateFormat,
  } = props;

  const [date, setDate] = useState(initialValue || '');

  let maxDate = useMemo(() => {
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate());
    return minDate;
  }, []);

  const formatWeekDay = (week) => {
    return week.substring(0, 3);
  };

  const handleChange = (date) => {
    setDate(date);
    onChange(date);
  };

  return (
    <div className={cn(styles.datepickerWrapper, 'datapicker-wrapper')}>
      <DatePicker
        selected={date}
        className={styles.datepicker}
        onChange={handleChange}
        placeholderText={placeholder}
        onKeyDown={(e) => e.preventDefault()}
        formatWeekDay={formatWeekDay}
        maxDate={maxDate}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={60}
        customInput={<CustomInput placeholder={placeholder} />}
        dateFormat={dateFormat}
      />
    </div>
  );
};

export default DatePickerComponent;
